const AccountType = {
  Basic: "basic",
  TNVS: "tnvs",
};

export default AccountType;
